import { mergeStyleSets } from "@fluentui/react";
import CancelIcon from "@mui/icons-material/Cancel";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import React from "react";

// Optimized validation suffix styles
const validationSuffixStyles = mergeStyleSets({
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
    borderRadius: "50%",
    margin: "2px"
  },
  icon: {
    fontSize: "14px",
    lineHeight: "16px"
  }
});

// Icon configuration for validation states
const VALIDATION_ICONS = {
  valid: <TaskAltIcon style={{ color: "#107c10", fontSize: "inherit" }} />,
  invalid: <CancelIcon style={{ color: "#d13438", fontSize: "inherit" }} />
} as const;

interface SessionNameValidationSuffixProps {
  isSessionNameValid: boolean | null;
}

export const SessionNameValidationSuffix: React.FC<SessionNameValidationSuffixProps> = React.memo(
  ({ isSessionNameValid }) => {
    if (isSessionNameValid === null) return null;

    const iconKey = isSessionNameValid ? "valid" : "invalid";

    return (
      <span className={validationSuffixStyles.container}>
        <span className={validationSuffixStyles.icon}>{VALIDATION_ICONS[iconKey]}</span>
      </span>
    );
  }
);

SessionNameValidationSuffix.displayName = "SessionNameValidationSuffix";
